// extracted by mini-css-extract-plugin
module.exports = {"latest-stories":"latestStories-m__latest-stories__3QRMo","story-container":"latestStories-m__story-container__V-ibS","story-title":"latestStories-m__story-title__1036p"};